// extracted by mini-css-extract-plugin
export default {"summary":"FooterSummary_summary__TB+4X","text":"FooterSummary_text__8aLmM"};